import {
  Box,
  MenuRenderer,
  MenuItem,
  IconChevron,
  Text,
} from 'braid-design-system';

import { useLanguageAITaxonomy } from 'src/app/shared/taxonomies/useLanguageAITaxonomy';
import { FourPointedStarIcon } from 'src/app/v1/views/shared/Icons/FourPointedStarIcon';
import type { LanguageAI } from 'src/types/languageAI';

interface LanguageSelectionAIContentGenerateButtonProps {
  buttonText: string;
  buttonStyle: string;
  buttonTextStyle: string;
  generationLanguages: LanguageAI[];
  handleOnClick: (language: LanguageAI) => void;
}

export const LanguageSelectionAIContentGenerateButton = ({
  buttonText,
  buttonStyle,
  buttonTextStyle,
  generationLanguages,
  handleOnClick,
}: LanguageSelectionAIContentGenerateButtonProps) => {
  const { getLanguageAIText } = useLanguageAITaxonomy();

  return (
    <MenuRenderer
      offsetSpace="none"
      align="right"
      width="small"
      trigger={(triggerProps, { open }) => (
        <Box
          component="button"
          className={buttonStyle}
          type="button"
          cursor="pointer"
          userSelect="none"
          borderRadius="standard"
          display="flex"
          alignItems="center"
          justifyContent="center"
          marginLeft="gutter"
          paddingX="medium"
          data-testid="ai-generation-cta-language-options"
          {...triggerProps}
        >
          <FourPointedStarIcon />
          <Text maxLines={1}>
            <Box component="span" className={buttonTextStyle}>
              {buttonText}
              <IconChevron
                direction={open ? 'up' : 'down'}
                alignY="lowercase"
              />
            </Box>
          </Text>
        </Box>
      )}
    >
      {generationLanguages.map((language) => (
        <MenuItem
          key={`language-option-${language}`}
          onClick={() => handleOnClick(language)}
        >
          {getLanguageAIText(language)}
        </MenuItem>
      ))}
    </MenuRenderer>
  );
};
